module.exports = __webpack_public_path__ + "img/donor-bg.66b985a8.jpg";